<template>
  <div class="finding-tenant-page">
    <v-img alt="Logo" class="shrink mr-2 app tenant-logo" contain :src="logoimage" transition="scale-transition" />

    <v-sheet class="folded-corner tenant-panel">
      <v-container fluid class="tenant-container">
        <v-card elevation="0" class="tenant-card align-center mx-auto">
          <header class="tenant-header">
            <h1>{{ "รายชื่อบริษัท" }}</h1>
            <p>{{ "LIST OF COMPANY NAMES" }}</p>
            <v-divider class="tenant-divider"></v-divider>
          </header>

          <section class="tenant-search-area">
            <div class="selected-tenant" :class="{ empty: ShowData == '' }">
              {{ ShowData || "เลือกบริษัทที่ต้องการติดต่อ" }}
            </div>

            <v-text-field
              outlined
              hide-details
              v-model="SearchTenant"
              ref="inputTenant"
              class="tenant-search-input"
              placeholder="Search company name"
            ></v-text-field>

            <v-virtual-scroll
              v-if="SearchTenant != ''"
              v-model="selectedItem"
              class="tenant-result-list"
              :items="TenantList"
              height="168"
              item-height="56"
            >
              <template v-slot:default="{ item }">
                <v-list-item :key="item.tenantID || item.nameEng" class="tenant-result-item" @click="dataTenant(item)">
                  <v-list-item-content>
                    <v-list-item-title class="tenant-result-row">
                      <strong class="tenant-name-eng">{{ item.nameEng }}</strong>
                      <strong class="tenant-name-th">{{ item.nameThai == '-' ? '' : item.nameThai }}</strong>
                      <span class="tenant-floor">{{ $t("message.Floor") }}: <strong>{{ item.floorID }}</strong></span>
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </template>
            </v-virtual-scroll>
            <div v-else class="tenant-result-list tenant-result-placeholder">
              พิมพ์ชื่อบริษัทเพื่อค้นหา
            </div>
          </section>

          <section class="tenant-keyboard-panel">
            <MultiSimpleKeyboardTenant @onChange="onChangeTenant" />
          </section>

          <div class="tenant-actions">
            <v-card elevation="0" color="#344054" class="box white--text text-capitalize tenant-action-btn"
              @click="BackToIdentifySelection()">
              <span>{{ $t("message.Back") }}</span>
            </v-card>
            <v-card elevation="0" color="#344054" class="box white--text text-capitalize tenant-action-btn"
              :class="{ disabled: ShowData == '' }" @click="printQr()">
              <span>{{ $t("message.Continue") }}</span>
            </v-card>
          </div>
        </v-card>
      </v-container>
    </v-sheet>


    <v-dialog v-model="LoadingDialog" persistent width="300">
      <v-card color="#1D2939" dark>
        <v-card-text class="white--text">
          <v-row>
            <p style="text-align: center">Loading</p>
          </v-row>
          <v-row>
            <v-progress-linear indeterminate color="#ffffff" class="mb-0"></v-progress-linear>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import axios from "axios";
import enurl from "@/api/environment";
import MultiSimpleKeyboardTenant from "@/components/MultiSimpleKeyboard";
// import logoimage from "@/assets/OneBangkokLogo.png";
// import ChangeLanguage from "@/components/ChangeLanguage";
export default {
  name: "FindingTenant",
  components: {
    MultiSimpleKeyboardTenant,
    // ChangeLanguage,
  },
  data() {
    return {
      url: enurl.apiUrl,
      settingUrl: enurl.settingUrl,
      DefaultLogo: "@/assets/logo192.png",
      DefaultBG: "@/assets/1D2939.png",
      Datetime: "",
      LoadingDialog: false,
      selectedItem: null,

      inputTenantName: "",
      TenantName: "",
      Textkeyboard: "",
      SearchTenant: "",
      ShowData: "",
      ShowDataTh: "",
      TenantList: [],
      TenantListName: [],
      data: [],
      zoneName: "",
      tenantName: "",
      floorID: "",
      lang: "en",
      logoimage: "",
    };
  },

  mounted: function () {
    let self = this;
    console.log(self.$route.params.data);
    self.data = self.$route.params.data;
    self.lang = localStorage.getItem("lang");
    self.logoimage = require("@/assets/OneBangkokLogo.png");

    self.$refs.inputTenant.focus();
    // this.SearchDataTenant();
  },

  watch: {
    // SearchTenant: function (value) {
    //     let self = this;
    //     if(value.length > 3){
    //         self.SearchDataTenant(value);
    //     }
    // }

    '$i18n.locale'(newLocale, oldLocale) {
      console.log(`เปลี่ยนภาษา: ${oldLocale} → ${newLocale}`);
    }

  },

  methods: {
    dataTenant(item) {
      // let data = input.replace("undefined", "");
      // this.SearchTenant = data;
      let self = this;
      let textTh = item.nameThai == "-" ? "" : item.nameThai;


      let text = item.nameEng  + '  ' + textTh + '  ' + 'F. ' + item.floorID;

      



      self.zoneName = item.zoneName;
      self.tenantName = item.tenantName;


      if (self.data != null) {
        if (self.data.documentNumber != undefined && self.data.documentNumber != "") {
          self.data.zoneID = item.zoneID;
          self.data.floorID = item.floorID;
          self.data.locationID = item.locationID;
          self.data.tenantID = item.tenantID;
          self.data.referenceQr = localStorage.getItem("LogId");
          self.data.ip = localStorage.getItem("IP");
        }
      }
      this.ShowData = text;
      this.ShowDataTh = textTh;
    },
    getCurrentDate() {
      let self = this;
      let newDate = new Date();
      let date =
        newDate.getDate() < 10 ? "0" + newDate.getDate() : newDate.getDate();
      let month = newDate.getMonth() + 1;
      let year =
        newDate.getFullYear() < 2500
          ? newDate.getFullYear() + 543
          : newDate.getFullYear();
      let hours =
        newDate.getHours() < 10 ? "0" + newDate.getHours() : newDate.getHours();
      let minutes =
        newDate.getMinutes() < 10
          ? "0" + newDate.getMinutes()
          : newDate.getMinutes();
      let seconds =
        newDate.getSeconds() < 10
          ? "0" + newDate.getSeconds()
          : newDate.getSeconds();
      self.Datetime = `${date}/${month < 10 ? `0${month}` : `${month}`
        }/${year}  ${hours}:${minutes}:${seconds}`;
    },

    select() {
      this.$refs.inputTenant.select();
    },

    onChangeTenant(input) {
      let self = this;
      self.SearchTenant = input;
      self.SearchDataTenant();
    },

    BackToIdentifySelection() {
      let self = this;
      self.$router.push("/MainMenu");
      // self.$router.push("/CapturePerson");
    },
    printQr() {
      let self = this;
      if (self.ShowData == "") {
        return;
      }

      // self.$router.push("/PrintQr");
      self.$router.push({
        name: "PrintQr",
        path: "/PrintQr",
        params: {
          data: self.data,
          zoneName: self.zoneName,
          tenantName: self.tenantName,
        },
      });
    },

    CapturePerson() {
      let self = this;
      self.$router.push("/CapturePerson");
    },

    // SearchDataTenant(value) {
    //   let self = this;
    //   let temp = {
    //     search: value,
    //   };
    //   axios
    //     .post(`${self.url}Main/searchDataTenant`, temp)
    //     .then(function(response) {
    //       if (response.data.status == 0) {
    //         self.TenantList = response.data.data;
    //         console.log(response.data.data);
    //       }
    //     })
    //     .catch(function(error) {
    //       self.MessageAlert = error;
    //     });
    // },

    SearchDataTenant() {
      let self = this;
      let temp = {
        search: self.SearchTenant,
        lang: 'en',
      };
      axios
        .post(`${self.url}VMS/searchDataTenant`, temp)
        .then(function (response) {
          if (response.data.status == 0) {
            self.TenantList = response.data.data;
            // console.log(self.TenantList);
          }
          if (response.data.status == 1) {
            self.TenantList = [];
          }
        })
        .catch(function (error) {
          self.MessageAlert = error;
        });
    },
  },
};
</script>
<style scoped>
.finding-tenant-page {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: clamp(10px, 1.4vh, 18px);
  padding: clamp(12px, 2vw, 32px);
}

.finding-tenant-page .tenant-logo {
  width: min(27vw, 420px) !important;
  max-width: min(27vw, 420px) !important;
  margin: 0 !important;
}

.finding-tenant-page .tenant-panel {
  width: min(1240px, calc(100vw - 120px)) !important;
  height: min(82vh, 850px) !important;
  min-height: 0 !important;
  max-height: calc(100vh - 74px);
  margin: 0 auto !important;
  padding: clamp(18px, 2.2vw, 34px) clamp(24px, 2.8vw, 44px) clamp(52px, 5vh, 72px) !important;
}

.tenant-container {
  max-width: none !important;
  padding: 0 !important;
}

.tenant-card {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: space-between;
  height: 100%;
  gap: clamp(9px, 1.2vh, 15px);
  padding: clamp(8px, 1vh, 14px) clamp(22px, 2.2vw, 34px) clamp(24px, 2.4vh, 34px) !important;
  background: transparent !important;
}

.tenant-header {
  text-align: center;
}

.tenant-header h1 {
  color: #344054;
  font-size: clamp(28px, 2.5vw, 44px);
  font-weight: 900;
  line-height: 1.05;
  margin: 0;
}

.tenant-header p {
  color: #667085;
  font-size: clamp(17px, 1.4vw, 24px);
  font-weight: 800;
  line-height: 1.2;
  margin: 6px 0 0;
}

.tenant-divider {
  width: min(520px, 42vw);
  margin: 10px auto 0;
  border-top-width: 5px !important;
  border-color: #344054 !important;
}

.tenant-search-area {
  width: min(920px, 100%);
  margin: 0 auto;
}

.selected-tenant {
  min-height: 32px;
  display: block;
  color: #344054;
  font-size: clamp(14px, 0.9vw, 18px);
  font-weight: 900;
  text-align: center;
  white-space: nowrap;
  overflow-x: auto;
  overflow-y: hidden;
  -webkit-overflow-scrolling: touch;
  padding: 2px 10px 6px;
  margin-bottom: 8px;
}

.selected-tenant.empty {
  color: #98a2b3;
  font-weight: 700;
  overflow: hidden;
}

.selected-tenant::-webkit-scrollbar {
  height: 5px;
}

.selected-tenant::-webkit-scrollbar-thumb {
  background: rgba(52, 64, 84, 0.45);
  border-radius: 999px;
}

.tenant-search-input {
  margin-bottom: 10px;
}

.tenant-search-input ::v-deep input {
  color: #111827;
  font-size: clamp(24px, 1.9vw, 34px) !important;
  font-weight: 800;
  text-align: center;
}

.tenant-search-input ::v-deep .v-input__slot {
  min-height: 52px !important;
  border-radius: 12px !important;
  background: rgba(255, 255, 255, 0.92) !important;
  box-shadow:
    inset 0 2px 6px rgba(16, 24, 40, 0.08),
    0 10px 18px rgba(16, 24, 40, 0.08);
}

.tenant-result-list {
  height: min(16vh, 168px) !important;
  border: 1px solid rgba(52, 64, 84, 0.18);
  border-radius: 12px;
  background: rgba(255, 255, 255, 0.82);
  overflow-y: auto !important;
  overflow-x: hidden;
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.8);
}

.tenant-result-list::-webkit-scrollbar {
  width: 9px;
}

.tenant-result-list::-webkit-scrollbar-thumb {
  background: rgba(52, 64, 84, 0.5);
  border-radius: 999px;
}

.tenant-result-placeholder {
  display: flex;
  align-items: center;
  justify-content: center;
  color: #98a2b3;
  font-size: clamp(17px, 1.25vw, 22px);
  font-weight: 800;
}

.tenant-result-item {
  min-height: 56px !important;
  border-bottom: 1px solid rgba(52, 64, 84, 0.08);
}

.tenant-result-item:hover {
  background: rgba(52, 64, 84, 0.08);
}

.tenant-result-row {
  display: grid;
  grid-template-columns: minmax(0, 1.15fr) minmax(0, 1fr) auto;
  align-items: center;
  gap: 14px;
  color: #111827;
  font-size: clamp(15px, 1.05vw, 19px);
}

.tenant-name-eng,
.tenant-name-th {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.tenant-floor {
  color: #344054;
  font-weight: 800;
  white-space: nowrap;
}

.tenant-keyboard-panel {
  width: min(980px, 100%);
  margin: 4px auto 0;
  padding: 7px;
  border-radius: 12px;
  background: rgba(248, 250, 252, 0.92);
  box-shadow:
    inset 0 1px 0 rgba(255, 255, 255, 0.88),
    0 14px 28px rgba(16, 24, 40, 0.12);
}

.tenant-actions {
  width: min(820px, 100%);
  display: grid;
  grid-template-columns: repeat(2, minmax(220px, 1fr));
  gap: clamp(22px, 4vw, 56px);
  margin: 10px auto 0;
}

.tenant-action-btn {
  width: 100% !important;
  min-height: 88px !important;
  display: inline-flex !important;
  align-items: center;
  justify-content: center;
  font-size: clamp(24px, 2vw, 34px) !important;
  font-weight: 900 !important;
  line-height: 1.05;
}

.tenant-action-btn span {
  position: relative;
  z-index: 1;
  color: #ffffff;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.32);
}

.tenant-action-btn.disabled {
  cursor: default;
  opacity: 0.58;
  filter: grayscale(0.2);
}

.tenant-action-btn.disabled::before,
.tenant-action-btn.disabled::after {
  opacity: 0.35;
}

@media all and (orientation: portrait) {
  .fullscreen {
    height: 1890px;
  }
}

@media all and (orientation: landscape) {
  .fullscreen {
    height: auto;
  }
}
</style>
